/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';


export class identification extends IceEntity {
  identification_key: string = "";
  identification_code: string = "";
  identification_code_qualifier: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
      super();
  }

  gettablename(): string {
      return "IDENTIFICATION";
  }
}
